<!-- src/components/Applications/UppsognSereign/Steps/Step2.vue -->
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// custom rule: at least one of the two checkboxes must be checked
const oneSelected = helpers.withMessage(
  () => t('umsokn_uppsogn_samning_step2_vorsluadili_error'),
  () => !!(umsokn.value?.isVidbotarlifeyrissparnadur || umsokn.value?.isTilgreindSereign)
)

const rules = {
  umsokn: {
    currentCustodian: { required },
  },
  atLeastOneSelected: { oneSelected },
}

const v$ = useVuelidate(rules, { umsokn, atLeastOneSelected: computed(() => true) }, { $autoDirty: true })

// ApplicationBase will call this before advancing
defineExpose({
  async validate() {
    const ok = await v$.value.$validate()
    return ok
  },
})
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col cols="12">
          <p class="forms__header" style="font-size: 18px">
            {{ t('umsokn_uppsogn_samning_step2_header3') }}
          </p>
        </v-col>

        <v-col cols="12" md="8">
          <v-checkbox
            v-model="umsokn.isVidbotarlifeyrissparnadur"
            :label="t('umsokn_uppsogn_samning_step2_vidbotarlifeyrissparnadur')"
            :readonly="props.disable"
            density="comfortable"
            hide-details
          />
          <v-checkbox
            v-model="umsokn.isTilgreindSereign"
            :label="t('umsokn_uppsogn_samning_step2_tilgreindSereign')"
            :readonly="props.disable"
            density="comfortable"
            hide-details
          />

          <div class="error__text" v-if="v$.atLeastOneSelected.$error">
            {{ t('umsokn_uppsogn_samning_step2_vorsluadili_error') }}
          </div>
        </v-col>

        <v-col cols="12">
          <p class="forms__header" style="font-size: 18px">
            {{ t('umsokn_uppsogn_samning_step2_nuverandi') }}
          </p>
        </v-col>

        <v-col cols="12" md="8">
          <v-text-field
            v-model="umsokn.currentCustodian"
            :label="t('umsokn_uppsogn_samning_step2_vorsluadili')"
            :placeholder="t('umsokn_uppsogn_samning_step2_vorsluadili')"
            :readonly="props.disable"
            variant="outlined"
            :error="v$.umsokn.currentCustodian.$error"
            :error-messages="
              v$.umsokn.currentCustodian.$error
                ? [t('umsokn_uppsogn_samning_step2_vorsluadili_error')]
                : []
            "
            hide-details="auto"
          />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-b-40 { margin-bottom: 40px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
.error__text {
  color: #b00020;
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
